import CaptchaBox from './Captcha'
const componets = [
  CaptchaBox
]

const CZURUI = {
  install: function (Vue, opts = {}) {
    componets.forEach(componet => {
      Vue.component(componet.name, componet)
    })
    Vue.prototype.$showCaptcha = CaptchaBox.show
    Vue.prototype.$initCaptcha = CaptchaBox.initCaptcha
  }
}

export default CZURUI



// WEBPACK FOOTER //
// ./src/components/index.js